<!-- 财富号接口公告 -->
<template>
  <div v-if="!$isEmpty(cfhTips)" class="tip-box" @click="$goFundApp">
    <div v-for="(tip, index) in cfhTips" :key="index" class="tip-item">{{tip.content}}</div>
  </div>
</template>

<script>
export default {
  name: 'cfh-announce',

  props: {
    cfhInfo: {
      type: Object,
      default: () => ({}),
    },
  },

  computed: {
    cfhTips() {
      return this.cfhInfo?.fundAnnouncement || [];
    },
  },
};
</script>

<style lang="less" scoped>
.tip-box {
  width: 100%;
  margin-bottom: 24px;
}
.tip-item {
  padding: 24px;
  background-color: #FFFDEB;
  border: 1px solid #FFE780;
  border-radius: 12px;
  font-size: 28px;
  line-height: 42px;
  color: #333333;
}
</style>
